import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import Services from '../../services/service';
import withNotification from '../../components/HOCNotification/HOCNotification.component';

class BasInstanceTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      instanceData: this.props.instanceData
    };
    this.initialState = this.state;
  }

  handleBasControlAction = async (instanceNumber, status, idx) => {
    const params = { instanceNumber };
    const payload = { status };

    Services.putBasControlAction(payload, params).then(res => {
      const newInstanceData = [...this.state.instanceData];
      newInstanceData[idx].status = status;
      this.setState({ instanceData: newInstanceData });
      
      this.props.addNotification('success', 'Success', res.msg, 'top-right');
    }).catch(err => {
      console.log(err);
      const message = err?.response?.data?.error;
      this.props.addNotification('danger', 'Failed', message ?? 'Oops something went wrong !', 'top-right');
    })
  }


  renderInstancesTable = () => {
    const { instanceData } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "instanceNumber",
        label: "Instance Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "propertyId",
        label: "Property ID",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Current Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value.toString()
        }
      },
      {
        name: "instanceNumber",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          // setCellProps: () => ({ style: { minWidth: "100px" } }),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="switcher align-self-center">
                <input
                  type="checkbox"
                  name={`switcher_${value}`}
                  id={`switcher_${value}`}
                  checked={instanceData[tableMeta.rowIndex].status}
                  onChange={(e) => { 
                    this.handleBasControlAction(value, e.target.checked, tableMeta.rowIndex); 
                  }}
                />
                <label htmlFor={`switcher_${value}`}></label>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
    };

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Instance"}
          data={instanceData}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    )
  };

  render() {
    return (
      <>
        {this.renderInstancesTable()}
      </>
    )
  }
}

export default withNotification(BasInstanceTable);
